/**
 * Takes a value between 0 and 1 and convert it to percentage
 * @example
 * formatPercentage(0.1234, undefined, "en-US") // "12%"
 */
export function formatPercentage(value: number, decimals = 0, locale: string): string {
    return value.toLocaleString(locale, {
        style: "percent",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
}

/**
 * Takes 2 number, divides value by total and converts it to a number between 0 and 100, with specified decimals, and add a % at the end.
 */
export function formatToPercentage(value: number, total: number, decimals: number = 0, locale: string): string {
    return formatPercentage(toPercentage(value, total, decimals) / 100, decimals, locale);
}

/**
 * Takes a 2 number, divides value by total and converts it to a number between 0 and 100, with specified decimals
 */
export function toPercentage(value: number, total: number, decimals: number = 0): number {
    if (total === 0) {
        return 0;
    }

    if (decimals > 0) {
        return parseFloat(((value / total) * 100).toFixed(decimals));
    }

    return Math.round((value / total) * 100);
}
